import React from 'react';
import { Link } from 'react-router-dom';
import Typewriter from 'react-typewriter-effect';
import './styles/Home.css';

function Home() {
    return (
        <main className="home">
            <div className="home__container">
                {/* Left Section - Text */}
                <div className="home__text">
                    <p>Our team studies how humans collaborate with artificial agents in complex tasks. We explore how
                        different types of AI, from avatars to humanoid robots, affect team performance and
                        communication in problem-solving situations.</p>

                    <p>Through multidisciplinary research combining computational linguistics, cognitive science,
                       economics, and human-computer interaction, we're developing new frameworks for effective
                       human-AI teamwork in high-stakes analytical environments.</p>

                    <div className="home__button-container">
                        <Link to="/about" className="home__button">Learn More</Link>
                        <Link to="/contact" className="home__button home__button--secondary">Contact Us</Link>
                    </div>
                </div>

                {/* Right Section - Image */}
                <div className="home__image">
                    <img src={`${process.env.PUBLIC_URL}/images/centro_piaggio.png`} alt="Centro Piaggio Logo"/>
                    <img src={`${process.env.PUBLIC_URL}/images/CNRimage.png`} alt="CNR Logo"/>
                </div>
            </div>

            {/* Title with typewriter effect */}
            <div className="home__title">
                <Typewriter
                    text="Bridging Minds and Machines for Smarter Teamwork"
                    typeSpeed={70}
                    startDelay={500}
                    cursorColor="#f1910d"
                    textStyle={{
                        fontSize: '32px',
                        fontWeight: 'bold',
                        letterSpacing: '1px',
                        color: '#333',
                        textAlign: 'center',
                        margin: '0 auto',
                        maxWidth: '800px'
                    }}
                />
            </div>
        </main>
    );
}

export default Home;